module.exports = __webpack_public_path__ + "static/media/cybercrime@3x.4665d699.png";